// extracted by mini-css-extract-plugin
export var container = "card-module--container--xcXA-";
export var empty = "card-module--empty--liZrf";
export var filled = "card-module--filled--vAtnZ";
export var img_logo = "card-module--img_logo--yDPcI";
export var name = "card-module--name--3+g7Z";
export var rate = "card-module--rate--I1aLR";
export var review = "card-module--review---tDO0";